import { render, staticRenderFns } from "./AS_Circulars.vue?vue&type=template&id=32a1e385&scoped=true&"
import script from "./AS_Circulars.vue?vue&type=script&lang=js&"
export * from "./AS_Circulars.vue?vue&type=script&lang=js&"
import style0 from "./AS_Circulars.vue?vue&type=style&index=0&id=32a1e385&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a1e385",
  null
  
)

export default component.exports